import * as React from 'react';

function TablesIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.8H13C13.6627 1.8 14.2 2.33726 14.2 3V4H9V1.8ZM7 0H9H13C14.6569 0 16 1.34315 16 3V4V6V8V10V11.0567C16 12.239 15.2974 13.3016 14.1499 13.5864C12.793 13.9233 10.715 14.28 8 14.28C5.28496 14.28 3.20696 13.9233 1.85008 13.5864C0.702562 13.3016 0 12.239 0 11.0567V10V8V6V4V3C0 1.34315 1.34315 0 3 0H7ZM7 1.8L7 4H1.8V3C1.8 2.33726 2.33726 1.8 3 1.8H7ZM7 6H1.8V8H7V6ZM7 10H1.8V11.0567C1.8 11.2954 1.87134 11.4879 1.962 11.6155C2.04661 11.7346 2.15178 11.8067 2.28373 11.8395C3.3459 12.1031 4.93534 12.39 7 12.4626L7 10ZM9 12.4626V10H14.2V11.0567C14.2 11.2954 14.1287 11.4879 14.038 11.6155C13.9534 11.7346 13.8482 11.8067 13.7163 11.8395C12.6541 12.1031 11.0647 12.39 9 12.4626ZM9 8L9 6H14.2V8H9Z"
        className="fill-icn-txt-prim"
      />
    </svg>
  );
}

export default TablesIcon;
